<template>
  <v-dialog v-model="visible" max-width="700" scrollable>
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn
        v-bind="activatorProps"
        icon="mdi-help-circle-outline"
        variant="text"
        size="small"
        density="compact"
        :title="dialogTitle"
      />
    </template>
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon start>{{ type === 'manipulations' ? 'mdi-alert-decagram' : 'mdi-brain' }}</v-icon>
        {{ dialogTitle }}
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" @click="visible = false" />
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4" style="max-height: 70vh;">
        <div v-for="item in items" :key="item.code" class="mb-4">
          <div class="d-flex align-center mb-1">
            <v-chip size="small" :color="item.color" variant="flat" class="mr-2 font-weight-bold">
              {{ item.name }}
            </v-chip>
          </div>
          <div class="text-body-2 mb-1">{{ item.description }}</div>
          <div class="text-body-2 text-grey-darken-1 font-italic">
            <v-icon size="x-small" class="mr-1">mdi-format-quote-open</v-icon>
            {{ item.example }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const MANIPULATIONS = [
  {
    code: 'EMO',
    name: 'Эмоциональное разжигание',
    color: '#F44336',
    description: 'Вызывание страха, гнева через ярлыки и гиперболы, обилие восклицательных знаков.',
    example: '«Враги народа уничтожают нашу страну! Это КАТАСТРОФА!!!»'
  },
  {
    code: 'CLK',
    name: 'Кликбейт / сенсационность',
    color: '#E91E63',
    description: 'Привлечение внимания через сенсационные заголовки без содержательной основы.',
    example: '«СРОЧНО! Вы не поверите, что произошло...»'
  },
  {
    code: 'FRM',
    name: 'Эффект формулировки',
    color: '#9C27B0',
    description: 'Навязывание определённой интерпретации событий через оценочные эпитеты.',
    example: '«Скандальное решение режима вызвало волну возмущения»'
  },
  {
    code: 'CHR',
    name: 'Манипуляция фактами',
    color: '#673AB7',
    description: 'Выборочная подача фактов, использование только удобных данных без сравнения.',
    example: '«Опрос показал, что 70% против» (при выборке из 50 человек в одном городе)'
  },
  {
    code: 'CSE',
    name: 'Ложная причинность',
    color: '#3F51B5',
    description: 'Утверждение причинно-следственной связи без доказательств.',
    example: '«Из-за нового закона экономика рухнула» (без анализа других факторов)'
  },
  {
    code: 'DLM',
    name: 'Ложная дилемма',
    color: '#2196F3',
    description: 'Представление ситуации как выбора только из двух вариантов.',
    example: '«Либо вы с нами, либо вы предатель»'
  },
  {
    code: 'STR',
    name: 'Соломенное чучело',
    color: '#009688',
    description: 'Искажение позиции оппонента до карикатурной, чтобы легче её опровергнуть.',
    example: '«Они хотят, чтобы мы полностью отказались от армии!» (хотя речь о реформе)'
  },
  {
    code: 'WBT',
    name: '«А как же...»',
    color: '#FF9800',
    description: 'Переключение внимания на действия другой стороны вместо ответа по существу.',
    example: '«А почему вы молчали, когда они делали то же самое?»'
  },
  {
    code: 'ADH',
    name: 'Атака на личность',
    color: '#FF5722',
    description: 'Атака на личность оппонента вместо обсуждения аргументов.',
    example: '«Что может сказать человек, который сам никогда не работал?»'
  },
  {
    code: 'PSR',
    name: 'Псевдоавторитеты',
    color: '#795548',
    description: 'Ссылка на неопределённые авторитетные источники без конкретики.',
    example: '«Источник, близкий к Кремлю, сообщил...», «Эксперты считают...»'
  },
  {
    code: 'FEQ',
    name: 'Ложное эквивалентирование',
    color: '#607D8B',
    description: 'Представление двух неравнозначных позиций как равноценных.',
    example: '«Одни учёные говорят Земля круглая, другие — плоская. Истина посередине»'
  },
  {
    code: 'FLA',
    name: 'Ложная аналогия',
    color: '#00BCD4',
    description: 'Сравнение несопоставимых вещей для обоснования вывода.',
    example: '«Управление страной — как управление семьёй, нужна жёсткая рука»'
  },
  {
    code: 'FPR',
    name: 'Ложные обещания',
    color: '#4CAF50',
    description: 'Обещания выгод или результатов без объективных оснований.',
    example: '«После принятия закона все проблемы исчезнут за месяц»'
  },
  {
    code: 'APU',
    name: 'Апелляция к большинству',
    color: '#CDDC39',
    description: 'Апелляция к мнению большинства как доказательство правоты.',
    example: '«Все нормальные люди понимают, что это правильно»'
  },
  {
    code: 'QMI',
    name: 'Вырывание из контекста',
    color: '#FFEB3B',
    description: 'Вырывание цитаты из контекста для изменения её смысла.',
    example: '«Президент сказал: "это провал"» (полная фраза: «Оппозиция считает, что это провал»)'
  },
  {
    code: 'FATTR',
    name: 'Ложное приписывание',
    color: '#8D6E63',
    description: 'Приписывание человеку слов или позиции, которые он не высказывал.',
    example: '«Министр фактически признал крах экономики» (хотя он этого не говорил)'
  }
];

const COGNITIVE_BIASES = [
  {
    code: 'CTS',
    name: 'Катастрофизация',
    color: '#F44336',
    description: 'Преувеличение негативных последствий событий до масштаба катастрофы.',
    example: '«Это решение приведёт к полному краху всей отрасли!»'
  },
  {
    code: 'LAB',
    name: 'Навешивание ярлыков',
    color: '#E91E63',
    description: 'Использование обобщённых негативных характеристик вместо анализа.',
    example: '«Все чиновники — воры и коррупционеры»'
  },
  {
    code: 'THR',
    name: 'Чтение мыслей',
    color: '#9C27B0',
    description: 'Приписывание мотивов или намерений без объективных оснований.',
    example: '«Они специально это делают, чтобы навредить простым людям»'
  },
  {
    code: 'NFCS',
    name: 'Фокус на негативе',
    color: '#673AB7',
    description: 'Избирательное внимание к негативным аспектам при игнорировании позитивных.',
    example: '«В стране всё плохо» (игнорируя рост зарплат и снижение безработицы)'
  },
  {
    code: 'SHT',
    name: 'Долженствование',
    color: '#3F51B5',
    description: 'Категоричные утверждения о том, как «должно быть», без объективных оснований.',
    example: '«Государство обязано обеспечить каждого бесплатным жильём»'
  },
  {
    code: 'COM',
    name: 'Обобщение',
    color: '#2196F3',
    description: 'Выводы на основе единичных случаев с использованием «все», «никогда», «всегда».',
    example: '«Все молодые люди ленивые и не хотят работать»'
  },
  {
    code: 'EMD',
    name: 'Эмоциональное рассуждение',
    color: '#00BCD4',
    description: 'Использование эмоций как доказательства: «чувствую — значит правда».',
    example: '«Я чувствую, что нас обманывают, значит так и есть»'
  },
  {
    code: 'BW',
    name: 'Чёрно-белое мышление',
    color: '#009688',
    description: 'Восприятие ситуации только в крайностях, без полутонов.',
    example: '«Либо полная победа, либо тотальное поражение»'
  },
  {
    code: 'JWT',
    name: 'Каждый получает по заслугам',
    color: '#FF9800',
    description: 'Вера в то, что мир справедлив: «каждый получает по заслугам».',
    example: '«Раз у них проблемы — значит, сами виноваты»'
  },
  {
    code: 'PER',
    name: 'Персонализация',
    color: '#FF5722',
    description: 'Чрезмерное приписывание событий конкретной личности.',
    example: '«Всё это из-за одного человека — он лично во всём виноват»'
  },
  {
    code: 'FTL',
    name: 'Предсказание будущего',
    color: '#795548',
    description: 'Категоричные предсказания без достаточных оснований.',
    example: '«Через год страну ждёт неминуемый дефолт»'
  },
  {
    code: 'CFL',
    name: 'Иллюзия контроля/беспомощности',
    color: '#607D8B',
    description: 'Убеждённость в полном контроле ситуации или, наоборот, полной беспомощности.',
    example: '«Мы ничего не можем изменить, всё решено за нас»'
  }
];

export default {
  name: 'AnalysisHelpDialog',
  props: {
    type: {
      type: String,
      required: true,
      validator: (v) => ['manipulations', 'cognitive_biases'].includes(v)
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    dialogTitle() {
      return this.type === 'manipulations'
        ? 'Типы манипуляций'
        : 'Когнитивные искажения';
    },
    items() {
      return this.type === 'manipulations' ? MANIPULATIONS : COGNITIVE_BIASES;
    }
  }
};

// Export data for reuse in other components
export { MANIPULATIONS, COGNITIVE_BIASES };
</script>
